// @ts-check
import ListBox from 'Components/Common/listBox';
import UserSettingsStore from 'Stores/userSettingsStore';
import 'Styles/userSettings/assistentSearchSetting.scss';
import { observer } from 'mobx-react';
import React from "react";

/**
 * @param {{
 * cbMode?: boolean,
 * children: React.JSX.Element | React.JSX.Element[]
 * }} props 
 * @returns {React.JSX.Element}
 */
const AssistentSearchSetting = (props) => {
    let hasChildren = false;
    if (props.children) {
        if (Array.isArray(props.children))
            hasChildren = props.children.length > 0;
        else
            hasChildren = true;
    }

    const cbMode = props.cbMode ?? false;

    let title = 'Помощник:';
    if (cbMode && !hasChildren)
        title += ' не настроен';

    return (
        <div className={'assistent-search-setting' + (!hasChildren ? ' assistent-search-setting-hovered' : '')}>

            <div className='assistent-search-setting-input'>
                <div className='assistent-search-setting-title'>
                    <span className='search-assistent-title'>
                        {title}
                    </span>

                    {
                        cbMode ? '' :
                            <ListBox
                                id='search-assistent-listbox'
                                values={UserSettingsStore.selectAssistent.list}
                                withInput={true}
                                autoOpenOnListChange={true}
                                onSelectedItemChanged={(/** @type {any} */ key) => UserSettingsStore.SelectAssistent(key)}
                                inputValue={UserSettingsStore.selectAssistent.alias}
                                inputPlaceholder='Введите ФИО для поиска'
                                inputChange={(/** @type {any} */ key) => UserSettingsStore.SetSelectAssistentAlias(key)} />
                    }
                </div>

                {
                    cbMode ? '' :
                        <div className='assistent-search-value-block'>
                            <button
                                id='search-assistent-button'
                                onClick={() => UserSettingsStore.SearchAssistent()}>
                                Поиск
                            </button>
                        </div>
                }
            </div>

            {
                hasChildren ?
                    <div className='assistent-search-subblock'>
                        {props.children}
                    </div>
                    : ''
            }
        </div>
    )
}

export default observer(AssistentSearchSetting);